import mitt, { type Emitter, type Handler } from 'mitt';

type Events = Record<string, unknown>;

const emitter: Emitter<Events> = mitt<Events>();

// Generic API: callers specify the payload type to avoid casting inside the handler body.
// Example: EventBus.$on<AdvancedExportSettingsForm | null>('open-advanced-export-panel', (form) => …);
export default {
  $on<T = unknown>(type: string, handler: (event: T) => void): void {
    emitter.on(type, handler as Handler<unknown>);
  },
  $off<T = unknown>(type: string, handler?: (event: T) => void): void {
    emitter.off(type, handler as Handler<unknown>);
  },
  $emit<T = unknown>(type: string, event?: T): void {
    emitter.emit(type, event);
  },
};
